import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const OrganicPadsFeminineHygiene = () => {
  useMetaTags({
    title: "The Role of Organic Pads in Feminine Hygiene | Chemical-Free Protection",
    description: "Discover how organic pads promote better feminine hygiene with chemical-free protection. Reduce infection risks and maintain natural pH balance with organic menstrual care.",
    keywords: "organic pads, feminine hygiene, chemical-free sanitary pads, intimate health, menstrual care, organic sanitary products",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/organic-pads-feminine-hygiene",
    ogTitle: "The Role of Organic Pads in Feminine Hygiene",
    ogDescription: "Organic pads provide natural, chemical-free menstrual protection, promoting feminine hygiene and reducing the risk of infections.",
    ogImage: "https://images.pexels.com/photos/7691793/pexels-photo-7691793.jpeg?auto=compress&cs=tinysrgb&w=600",
    ogUrl: "https://organicpads.shop/organic-pads-feminine-hygiene",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "The Role of Organic Pads in Feminine Hygiene",
    twitterDescription: "Maintain optimal feminine hygiene with organic pads. Learn how chemical-free menstrual products support intimate health.",
    twitterImage: "https://images.pexels.com/photos/7691793/pexels-photo-7691793.jpeg?auto=compress&cs=tinysrgb&w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/organic-pads-feminine-hygiene"
    },
    "headline": "The Role of Organic Pads in Feminine Hygiene",
    "description": "Discover how organic pads promote better feminine hygiene with chemical-free protection. Reduce infection risks and maintain natural pH balance with organic menstrual care.",
    "image": "https://images.pexels.com/photos/7691793/pexels-photo-7691793.jpeg?auto=compress&cs=tinysrgb&w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "organic pads",
      "feminine hygiene",
      "chemical-free sanitary pads",
      "intimate health",
      "menstrual care",
      "organic sanitary products"
    ]
  }

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        The Role of Organic Pads in Feminine Hygiene
      </h1>
      <img
        src="https://images.pexels.com/photos/7691793/pexels-photo-7691793.jpeg?auto=compress&cs=tinysrgb&w=600"
        alt="Feminine Hygiene"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Maintaining proper feminine hygiene is essential for overall health and wellbeing. Organic pads play a crucial role in promoting better intimate health by offering natural, chemical-free protection during menstruation.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Hygiene Benefits</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Natural pH balance maintenance</li>
        <li>Reduced risk of infections</li>
        <li>Better air circulation</li>
        <li>Moisture control properties</li>
        <li>Chemical-free protection</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Maintain Optimal Hygiene?</h2>
      <p className="text-gray-700 mb-4">
        Select <strong>certified organic</strong> products and maintain regular changes. Proper storage and handling of organic pads ensures maximum hygiene benefits.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Hygiene Care"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Better hygiene leads to better health.
        <strong> Switch to organic for optimal intimate care!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default OrganicPadsFeminineHygiene;
